<template>
    <div class="ath-panel-header sp-l f fv fa-l">
        <div class="f fh sm-b-l fa-c">
            <div class="te-fat-section">{{ title | athT }}</div>
            <slot name="headerRight"></slot>
        </div>
        <p class="sm-t-s" v-if="desc">{{ desc | athT }}</p>
    </div>
</template>
<script>
export default {
    name: 'mead-panel-header',
    props: {
        /**
         * Title text displayed prominently in the panel header.
         */
        title: { type: String, default: ''},
        /**
         * Optional descriptive text shown below the title. Hidden entirely when false/empty.
         */
        desc: {type: [Boolean, String], default: false}
    }
};
</script>